import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Eye } from "lucide-react";
import { formatRemaining } from "@/hooks/useRestaurantPreview";

interface PreviewBarProps {
  restaurantName: string;
  expiresAt: string;
}

export function PreviewBar({ restaurantName, expiresAt }: PreviewBarProps) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 60_000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <div className="mb-4 rounded-xl border-2 border-cart bg-card shadow-md" role="status">
      <div className="flex flex-col items-center gap-3 px-4 py-3 text-center sm:flex-row sm:justify-between sm:text-left">
        <div className="flex items-start gap-2 text-sm">
          <Eye className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
          <span>
            Ön a <strong>{restaurantName}</strong> előnézeti ajánlatát látja a NapiHami.hu-n. Az előnézet érvényes még:{" "}
            <strong>{formatRemaining(expiresAt, now)}</strong>.
          </span>
        </div>
        <Link
          to="/etteremnek"
          id="btn-preview-offer"
          className="whitespace-nowrap rounded-full bg-cart px-5 py-2 text-sm font-semibold text-cart-foreground shadow transition hover:bg-cart/90"
        >
          Érdekel, megnézem az ajánlatot
        </Link>
      </div>
    </div>
  );
}
